<div>
  <!-- TODO Migration Angular 14 - add preserveContent to mat-tab-group -->
  <mat-tab-group
    mat-align-tabs="start"
    [selectedIndex]="selectedTab"
    (selectedTabChange)="tabChange($event)"
    animationDuration="0ms">
    <mat-tab>
      <ng-template matTabLabel>
        <span translate="metric-reports/list/dashboard-section-title"></span>
      </ng-template>
      <ng-template matTabContent>
        <app-dashboard-overview [routingTagItems]="routingTagItems" [routingTagLabel]="routingTagLabel">
        </app-dashboard-overview>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template matTabLabel>
        <span translate="metric-reports/admin-user/currently-logged-title"></span>
      </ng-template>
      <ng-template matTabContent>
        <app-dashboard-logged-users
          [roles]="roles"
          [routingTagItems]="routingTagItems"
          [routingTagLabel]="routingTagLabel">
        </app-dashboard-logged-users>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template matTabLabel>
        <span translate="metric-reports/list/reports-list-section-title"></span>
      </ng-template>
      <ng-template matTabContent>
        <app-dashboard-reports
          [roles]="roles"
          [scenarios]="scenarios"
          [customEvents]="customEvents"></app-dashboard-reports>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
